import { Children } from "react";
import type * as React from "react";

import { cn } from "../lib/cn";

export interface BoardLaneProps extends React.HTMLAttributes<HTMLElement> {
  title: string;
  children: React.ReactNode;
  ref?: React.Ref<HTMLElement>;
}

export function BoardLane({
  title,
  children,
  className,
  ...rest
}: BoardLaneProps) {
  return (
    <section
      aria-label={title}
      className={cn("flex flex-col gap-2.5", className)}
      {...rest}
    >
      <h2 className="text-mono-caps text-xs tracking-[0.18em] text-ink-body">
        {title}
      </h2>
      <div className="grid auto-cols-fr grid-flow-col gap-4">{children}</div>
    </section>
  );
}

export interface BoardColumnProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  count?: number;
  children?: React.ReactNode;
  ref?: React.Ref<HTMLDivElement>;
}

export function BoardColumn({
  title,
  count,
  children,
  className,
  ...rest
}: BoardColumnProps) {
  const empty = Children.toArray(children).length === 0;

  return (
    <div className={cn("flex min-w-0 flex-col gap-2.5", className)} {...rest}>
      <div className="flex items-baseline justify-between gap-2 border-b-[1.5px] border-ink pb-2.5">
        <h3 className="truncate text-mono-caps text-fine-print text-ink-body">
          {title}
        </h3>
        {count != null && count > 0 && (
          <span className="text-mono-time text-fine-print text-annotation">
            {count}
          </span>
        )}
      </div>
      {empty ? (
        <span
          aria-hidden="true"
          className="py-3.5 font-display text-[1.375rem] leading-none text-hollow"
        >
          &mdash;
        </span>
      ) : (
        children
      )}
    </div>
  );
}
